<!-- 作业反馈 -->
<template>
	<div>
		<div class="index">
			<div class="title">
				<div class="span1">
					<span>{{ $route.name }}</span>
				</div>
			</div>

			<div>
				<el-form :inline="true" :model="queryParams" label-width="45px">
					<el-form-item label="班级:">
						<el-select
							v-model="queryParams.classId"
							clearable
							placeholder="请选择"
							class="label classFrame"
						>
							<el-option
								v-for="item in classList"
								:key="item.classId"
								:label="item.className"
								:value="item.classId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="作业日期:" label-width="94px">
						<el-date-picker v-model="queryParams.homeworkDate" type="date" placeholder="请选择">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="学科:" label-width="74px">
						<el-select
							v-model="queryParams.subjectId"
							clearable
							placeholder="请选择"
							class="label"
							style="margin-right:200px"
						>
							<el-option
								v-for="item in SubjectList"
								:key="item.subjectId"
								:label="item.subjectName"
								:value="item.subjectId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="难易度:" label-width="60px">
						<el-select
							v-model="queryParams.difficulty"
							clearable
							placeholder="请选择"
							class="label"
						>
							<el-option
								v-for="item in difficultyList"
								:key="item.difficulty"
								:label="item.label"
								:value="item.difficulty"
							>
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="反馈日期:" label-width="94px">
						<el-date-picker v-model="queryParams.feedbackDate" type="date" placeholder="请选择">
						</el-date-picker>
					</el-form-item>

					<el-button type="primary" size="small" @click="searchFun()" class="findBtn"
						>查询</el-button
					>
				</el-form>

				<!-- 校内教师 -->
				<div class="table">
					<el-table :data="tableData" style="width: 100%" border>
						<el-table-column prop="username" label="反馈人" align="center">
						</el-table-column>
						<el-table-column prop="homeworkDate" label="作业日期" align="center" width="100">
						</el-table-column>
						<el-table-column prop="subjectName" label="学科" align="center" width="70">
						</el-table-column>
						<el-table-column prop="classname" label="学生班级" align="center" width="90">
						</el-table-column>
						<!-- <el-table-column prop="difficulty" label="反馈难易度" align="center" width="70">
							<template slot-scope="scope">
								<p v-if="scope.row.difficulty === 1">容易</p>
								<p v-if="scope.row.difficulty === 2">较易</p>
								<p v-if="scope.row.difficulty === 3">一般</p>
								<p v-if="scope.row.difficulty === 4">较难</p>
								<p v-if="scope.row.difficulty === 5">困难</p>
							</template>
						</el-table-column> -->
						<el-table-column prop="finishDuration" label="反馈完成时长" align="center" width="77">
						</el-table-column>
						<el-table-column prop="estimateDuration" label="预估完成时长" align="center" width="77">
						</el-table-column>
						<!-- <el-table-column prop="complete" label="作业完成情况" align="center" width="80">
							<template slot-scope="scope">
								<p v-if="scope.row.complete === '1'">完成</p>
								<p v-if="scope.row.complete === '0'">未完成</p>
							</template>
						</el-table-column> -->
						<!-- <el-table-column prop="suggestion" label="作业反馈意见" align="center">
							<template slot-scope="scope">
								<el-popover
									placement="bottom"
									width="150"
									:content="scope.row.suggestion"
									popper-class="popper-panel-more-allapp"
									trigger="hover"
									:open-delay="300"
								>
									<span slot="reference" class="show-hover ellipsis-m">
										{{ scope.row.suggestion }}</span
									>
								</el-popover>
							</template>
						</el-table-column> -->
						<el-table-column prop="feedbackDate" label="反馈时间" align="center"> </el-table-column>
						<el-table-column prop="" label="操作" align="center" width="65">
							<template slot-scope="scope">
								<el-button type="text" @click="toDetail(scope)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页组件 -->
					<div class="pagination">
						<el-pagination
							background
							:current-page="pageNum"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="pageSize"
							:total="totalPage"
							layout="total,prev, pager, next,jumper,sizes"
							@size-change="sizeChangeHandle"
							@current-change="currentChangeHandle"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { getHwFeedbackList, getSchHwFeedbackList } from "@/api/school/index.js";
	import dayjs from "dayjs";
	import localForage from "localforage";

	export default {
		components: {},
		data() {
			return {
				roles: [], //角色列表
				isAdmin: false, //是否是管理员或学科组长
				userType: "", //存储的用户角色
				tableData: [],
				classList: [],
				difficultyList: [
					{ difficulty: 1, label: "容易" },
					{ difficulty: 2, label: "较易" },
					{ difficulty: 3, label: "一般" },
					{ difficulty: 4, label: "较难" },
					{ difficulty: 5, label: "困难" },
				],
				pageNum: 1,
				pageSize: 10,
				totalPage: 0,
				queryParams: {
					classId: "",
					subjectId: "",
					homeworkDate: "",
					difficulty: "",
					feedbackDate: "",
				},

				detail: {
					info: {},
					show: false,
				},
				add: {
					info: {},
					show: false,
				},
				school_info: JSON.parse(sessionStorage.getItem("classList")),
				semesterArr: JSON.parse(sessionStorage.getItem("semesterList")),
			};
		},
		watch: {},
		activated() {
			this.getTableData();
		},
		created() {
			this.getCommonList();
			this.getUserType();
		},
		methods: {
			async getCommonList() {
				this.classList = await localForage.getItem("classList");
			},
			// 获取用户角色
			getUserType() {
				this.userType = sessionStorage.userType;
				console.log("this.userType--", this.userType);
				if (this.userType.search(/(G1|G3)/) > -1) {
					this.isAdmin = true;
				}
			},
			// 获取作业反馈列表
			async getTableData() {
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					classId: this.queryParams.classId,
					homeworkDate:
						(this.queryParams.homeworkDate &&
							dayjs(this.queryParams.homeworkDate).format("YYYY-MM-DD")) ||
						"",
					subjectId: this.queryParams.subjectId,
					difficulty: this.queryParams.difficulty,
					feedbackDate:
						(this.queryParams.feedbackDate &&
							dayjs(this.queryParams.feedbackDate).format("YYYY-MM-DD")) ||
						"",
				};
				let res;
				console.log("this.isAdmin--", this.isAdmin);
				if (this.isAdmin) {
					res = await getSchHwFeedbackList(params);
				} else {
					res = await getHwFeedbackList(params);
				}
				console.log("作业反馈列表--", res);
				let list = res?.list;
				list.forEach((item) => {
					item.homeworkDate = dayjs(item.homeworkDate).format("YYYY-MM-DD");
					item.feedbackDate = dayjs(item.feedbackDate).format("YYYY-MM-DD HH:mm");
					item.estimateDuration = item.estimateDuration + "分钟";
					item.finishDuration = item.finishDuration + "分钟";
					item.suggestion = item.suggestion || "——";
				});
				this.tableData = list;
				this.totalPage = res.total;
			},
			// 查看作业反馈详情
			toDetail(scope) {
				console.log("scope----1223", scope.row);
				this.$router.push({
					path: "/task/feedback/feedbackDetail",
					query: { homeworkId: scope.row.homeworkId, userId: scope.row.userid },
				});
			},
			//新增后刷新作业反馈列表
			refreshTableData() {
				this.getTableData();
			},

			searchFun() {
				this.pageNum = 1;
				this.getTableData();
			},
			sizeChangeHandle(val) {
				this.pageSize = val;
				this.getTableData();
			},
			currentChangeHandle(val) {
				this.pageNum = val;
				this.getTableData();
			},

			toIndex() {
				this.detail.show = false;
				this.add.show = false;
			},
		},
		mounted() {},
	};
</script>
<style lang="less" scoped>
	.index {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.title {
			height: 68px;
			line-height: 80px;
			border-bottom: 1px solid #eaeaea;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			.span1 {
				font-family: "PingFang SC Bold";
				font-weight: 500;
				font-size: 20px;
				text-align: left;
				color: #333;
			}
		}
		.findBtn {
			float: right;
			width: 80px;
			height: 32px;
			border-radius: 3px;
			background: #4991e1;
			font-size: 14px;
			margin-top: 5px;
		}
		.hwContent {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			> div:first-child img {
				width: 18px;
				height: 18px;
				margin-top: 6px;
				margin-right: 5px;
			}
			> div:last-child {
				text-align: left;
			}
		}
		.show-hover {
			cursor: pointer;
		}
		::v-deep .el-form-item__label {
			color: #333;
		}
		::v-deep .el-form .el-input__inner {
			width: 120px;
			height: 32px;
			border-radius: 3px;
			background: #fff;
			border: 1px solid #ddd;
		}

		::v-deep .el-table__header tr th {
			background: #f7f7f7;
			box-shadow: 0px 1px 0px #eaeaea;
		}
		::v-deep .el-table {
			color: #333;
		}

		::v-deep .el-date-editor .el-range-separator {
			line-height: 22px;
		}
		::v-deep .el-table thead th.el-table__cell {
			padding: 15 0.5px 0;
			font-weight: normal;
			font-size: 14px;
			color: #7a8da2;
			background: #fafafa;
		}
		::v-deep .el-table tbody td.el-table__cell {
			padding: 18.5px 0;
		}

		.pagination {
			text-align: center;
			margin-top: 30px;
		}
		.waitPreview {
			color: #4b83f7;
		}
		.inPreview {
			color: orange;
		}
		.passed {
			color: #50b173;
		}
		.rejected {
			color: #f74b4b;
		}
		.classFrame {
			::v-deep .el-input__inner {
				width: 135px;
			}
		}
		::v-deep .el-date-editor.el-input {
			width: 150px;
		}
		::v-deep .el-date-editor .el-input__inner {
			width: 150px !important;
		}
		::v-deep .el-icon-arrow-left {
			margin-top: 0;
		}
		::v-deep .el-icon-arrow-right {
			margin-top: 0;
		}
	}
</style>
